import React from "react";
import { DesignSystemOverviewLayout, DesignSystemSection, DesignSystemSectionRow } from "../DesignSystemHelpers";
import { ButtonListItem, ListItem } from "../../../designSystem/List/ListItem";


export const ListItemOverview = (): JSX.Element =>
{
    
    return (       
        <DesignSystemOverviewLayout>

            <DesignSystemSection title="ListItem">

                <DesignSystemSectionRow title="ListItem with icon and text">
                    <ListItem
                        leadingIcon="interface_user_user"
                        primaryContent="John Johnson"
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ListItem with icon and text and subtext">
                    <ListItem
                        leadingIcon="interface_user_user"
                        primaryContent="John Johnson"
                        secondary={{content:"11223344"}}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ListItem with icon and text and subtext and subicon">
                    <ListItem
                        leadingIcon="interface_user_user"
                        primaryContent="John Johnson"
                        secondary={{leadingIcon:"interface_glyph_phone", content:"11223344"}}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ListItem with icon and text and button">
                    <ListItem
                        leadingIcon="interface_user_user"
                        primaryContent="John Johnson"
                        buttons={[{ type:'button', icon:"add_circle", onClick:()=>{alert("clicked")}}]}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ListItem with icon and text and subtext and subicon and buttons">
                    <ListItem
                        leadingIcon="interface_user_user"
                        primaryContent="John Johnson"
                        secondary={{leadingIcon:"interface_glyph_phone", content:"11223344"}}
                        buttons={[
                            {type:'button', icon:"add_circle", onClick:()=>{alert("clicked")}},
                            {type:'button', destructive: true, icon:"interface_actions_edit", onClick:()=>{alert("clicked")}},
                        ]}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ListItem with icon and text and subtext and subicon and buttons and border and padding">
                    <ListItem
                        leadingIcon="interface_user_user"
                        primaryContent="John Johnson"
                        secondary={{leadingIcon:"interface_glyph_phone", content:"11223344"}}
                        buttons={[
                            {type:'button', icon:"add_circle", onClick:()=>{alert("clicked")}},
                            {type:'button', destructive: true, icon:"interface_actions_edit", onClick:()=>{alert("clicked")}},
                        ]}
                        border
                        padding="8px"
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ListItem with icon and text and subtext and subicon and buttons and border and padding and leadingIconBorder">
                    <ListItem
                        leadingIcon="interface_user_user"
                        primaryContent="John Johnson"
                        secondary={{leadingIcon:"interface_glyph_phone", content:"11223344"}}
                        buttons={[
                            {type:'button', icon:"add_circle", onClick:()=>{alert("clicked")}},
                            {type:'button', destructive: true, icon:"interface_actions_edit", onClick:()=>{alert("clicked")}},
                        ]}
                        border
                        padding="8px"
                        leadingIconBorder
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ListItem with icon and looooooooooooooooong text and subtext and subicon and buttons and border and padding and leadingIconBorder">
                    <ListItem
                        leadingIcon="interface_user_user"
                        primaryContent="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
                        secondary={{leadingIcon:"interface_glyph_phone", content:"11223344"}}
                        buttons={[
                            {type:'button', icon:"add_circle", onClick:()=>{alert("clicked")}},
                            {type:'button', destructive: true, icon:"interface_actions_edit", onClick:()=>{alert("clicked")}},
                        ]}
                        border
                        padding="8px"
                        leadingIconBorder
                    />
                </DesignSystemSectionRow>

            </DesignSystemSection>

            <DesignSystemSection title="ButtonListItem">

                <DesignSystemSectionRow title="ButtonListItem with icon and text">
                    <ButtonListItem
                        leadingIcon="interface_user_user"
                        primaryContent="John Johnson"
                        onClick={() => alert('clicked as button')}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ButtonListItem with icon and text and subtext">
                    <ButtonListItem
                        leadingIcon="interface_user_user"
                        primaryContent="John Johnson"
                        secondary={{content:"11223344"}}
                        onClick={() => alert('clicked as button')}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ButtonListItem with icon and text and subtext and subicon">
                    <ButtonListItem
                        leadingIcon="interface_user_user"
                        primaryContent="John Johnson"
                        secondary={{leadingIcon:"interface_glyph_phone", content:"11223344"}}
                        onClick={() => alert('clicked as button')}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ButtonListItem with icon and text and button">
                    <ButtonListItem
                        leadingIcon="interface_user_user"
                        primaryContent="John Johnson"
                        onClick={()=>{alert("clicked")}}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ButtonListItem with icon and text and subtext and subicon">
                    <ButtonListItem
                        leadingIcon="interface_user_user"
                        primaryContent="John Johnson"
                        secondary={{leadingIcon:"interface_glyph_phone", content:"11223344"}}
                        onClick={() => alert('clicked as button')}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="with long text">
                    <div style={{width:200, border:'1px dotted gray'}}>
                        <ButtonListItem
                            leadingIcon="interface_user_user"
                            primaryContent="this one has a veeeeeeeeeeeeeeeeeeeeery long nam that will be truncated"
                            secondary={{leadingIcon:"interface_glyph_phone", content:"11223344 and a lot more text that will be truncated"}}
                            onClick={()=>{alert("clicked")}}
                        />
                    </div>
                </DesignSystemSectionRow>

            </DesignSystemSection>

        </DesignSystemOverviewLayout>
    );
}

